module.exports = __webpack_public_path__ + "static/media/ship-map.430d5eea.svg";